<template>
  <div class="plr-table-hint-widget backdrop-dark fade-up">
    <div class="hint-container scrollable outline-cell">
      <div class="hint-toolbar">
        <button
          :disabled="!(tableHint?.duration && !isPaused)"
          @click="isPaused = true"
          class="btn-pause"
        />
        <button @click="handleCopyClick" class="ctrl-c" />
        <button @click="handleCloseClick" class="btn-close" />
      </div>
      <div class="plr-white-pane">
        <h4 v-if="tableHint?.title" :dir="getTextDirection(tableHint.title)">
          {{ tableHint?.title }}
        </h4>
        <div class="pan-area">
          <table ref="tableRef">
            <thead v-if="tableHint?.head?.length">
              <tr>
                <th v-for="(h, i) in tableHint.head" :key="i">{{ h }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in tableHint?.rows ?? []" :key="i">
                <td v-for="(v, i) in r" :dir="getTextDirection(v)" :key="i">
                  {{ v }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="tableHint?.notice" class="plr-sub-note">
          {{ tableHint.notice }}
        </div>
      </div>
      <ProgressBar
        :style="{
          visibility: tableHint?.duration && !isPaused ? 'visible' : 'hidden'
        }"
        :duration="tableHint.duration"
        :is-paused="isPaused"
        @end="handleProgressEnd"
        height="4"
        color="#FF681D"
        backgroundColor="#FFFFFF99"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { TableHintDto } from "@moderrotech/servers-communication-library/src/types";
import { getTextDirection } from "@/helpers/string";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import ProgressBar from "@/components/ProgressBar.vue";

// workaround to fix ts error
declare class ClipboardItem {
  constructor(data: { [mimeType: string]: Blob });
}

const tableRef = ref();

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const tableHint = computed(
      (): TableHintDto => store.state.session.tableHint
    );

    const isPaused = ref(false);

    return {
      tableRef,
      tableHint,
      getTextDirection,
      handleCloseClick: () => store.commit("session/UNSET_TABLE_HINT"),
      handleCopyClick: async () => {
        try {
          /* eslint-disable */
          // @ts-ignore
          await window.navigator.clipboard.write([
            new ClipboardItem({
              "text/html": new Blob([tableRef.value?.outerHTML ?? ""], {
                type: "text/html"
              })
            })
          ]);
          /* eslint-enable */
          showToastSuccess(i18n.global.t("call.success.textCopy"));
        } catch (err) {
          showToastError(i18n.global.t("call.error.textCopy"));
        }
      },
      handleProgressEnd: () => store.commit("session/UNSET_TABLE_HINT"),
      isPaused
    };
  }
};
</script>

<style lang="scss">
@import "../assets/styles/text-hint-table.scss";
@import "../assets/styles/kiosk-landscape-30inch/text-hint-table.scss";
@import "../assets/styles/kiosk-portrait-30inch/text-hint-table.scss";
</style>
